module.exports = __webpack_public_path__ + "static/media/brand-logo-light-no-tagline1.d217bd3a.png";